import PropTypes from "prop-types"
import React, { Fragment, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toggleSendBillingDialog } from "../../../../actions/billingDialogs"
import { openSnackBar } from "../../../../actions/snack-bar"
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@material-ui/core"
import EmailChip from "../../../EmailChip/index"
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter"

import useStyles from "./styles"
import GreenButton from "../../Common/GreenButton/index"

const SendBillingDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const open = useSelector(state => state.billingDialogs.sendBillingDialogOpen)
  const data = useSelector(state => state.billingDialogs.data)

  const [dialogValues, setDialogValues] = useState({
    recipients: [],
    email: "",
    subject: "",
    message: "",
  })

  //3 types -> estimate, invoice, reject - reject has some inherent conditionals w button, subject & header
  const type = (data && data.type) || ""
  const shootName = (data && data.shootName) || "This Shoot"
  const defaultEmail = (data && data.defaultEmail) || []
  const sendFunc = (data && data.sendFunc) || null
  const funcArgs = (data && data.funcArgs) || []

  const sendDisabled = !dialogValues.recipients.length || !dialogValues.subject

  useEffect(
    () => {
      if (data && data.type) {
        setDialogValues({
          ...dialogValues,
          subject: `Crew Mama ${
            type.toLowerCase() === "reject"
              ? "Refusal"
              : capitalizeFirstLetter(type)
          } for ${shootName}`,
          recipients: defaultEmail
            ? [...defaultEmail]
            : [...dialogValues.recipients],
        })
      }
    },
    [data]
  )

  // DEFAULT email address will be representative email address
  const handleClose = () => {
    setTimeout(() => {
      setDialogValues({
        recipients: [],
        email: "",
        subject: "",
        message: "",
      })
    }, 150)
    dispatch(toggleSendBillingDialog(false))
  }

  const handleChange = e => {
    const { name, value } = e.target
    setDialogValues({ ...dialogValues, [name]: value })
  }

  const handleSendFunction = () => {
    if (sendFunc) {
      sendFunc(dialogValues, ...funcArgs)
    }
    handleClose()
  }

  // format validation & error handling specifically for email
  const isEmailValid = email => {
    let error = null
    const regex = /[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/
    if (!regex.test(email)) {
      error = `${email} is not a valid email address.`
    }
    if (error) {
      dispatch(
        openSnackBar({
          message: "Not a valid email address, please check your entry!",
        })
      )
      return false
    }
    return true
  }

  // handle Press Enter on email input to add to recipients array
  const handleKeyPress = e => {
    if (["Enter"].includes(e.key)) {
      e.preventDefault()
      let email = dialogValues.email.trim()
      if (email && isEmailValid(email)) {
        setDialogValues({
          ...dialogValues,
          recipients: [...dialogValues.recipients, email],
          email: "",
        })
      }
    }
  }

  // when click X btn of an email address Chip
  const handleRemoveAddress = chip => {
    setDialogValues({
      ...dialogValues,
      recipients: dialogValues.recipients.filter(x => x !== chip),
    })
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">
          {type === "reject"
            ? "Reasons to refuse Crew Mama Deal Memo"
            : `Send ${type.charAt(0).toUpperCase() + type.slice(1)}`}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={2} mb={2}>
          <Typography variant="h5" className={classes.grayLabel}>
            Send to:
          </Typography>
          <Box className={classes.fakeInput}>
            {/* container for chips of recipients below */}
            {dialogValues.recipients.length > 0 &&
              dialogValues.recipients.map((x, i) => {
                return (
                  <Fragment key={i}>
                    <EmailChip
                      email={x}
                      deleteFunc={() => handleRemoveAddress(x)}
                    />
                  </Fragment>
                )
              })}
            <TextField
              id="email-addresses"
              name="email"
              variant="outlined"
              fullWidth
              value={dialogValues && dialogValues.email}
              onChange={handleChange}
              onKeyPress={handleKeyPress}
            />
          </Box>
          <Typography
            variant="subtitle1"
            style={{ fontSize: "12px", marginTop: "5px" }}
          >
            Add email, then press enter
          </Typography>
        </Box>
        <Box mt={2} mb={2}>
          <Typography variant="h5" className={classes.grayLabel}>
            Subject
          </Typography>
          <TextField
            id="email-subject"
            name="subject"
            variant="outlined"
            multiline
            fullWidth
            value={dialogValues && dialogValues.subject}
            onChange={handleChange}
          />
        </Box>
        <Box>
          <Typography variant="h5" className={classes.grayLabel}>
            Message
          </Typography>
          <TextField
            id="email-message"
            name="message"
            variant="outlined"
            multiline
            rows={6}
            rowsMax={12}
            placeholder="Optional"
            value={dialogValues && dialogValues.message}
            onChange={handleChange}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Box className={classes.buttons}>
          <GreenButton
            variant="contained"
            fullWidth
            onClick={() => handleSendFunction()}
            disabled={sendDisabled}
          >
            Send{" "}
            {type === "reject"
              ? "Explanation"
              : `${type.charAt(0).toUpperCase() + type.slice(1)}`}
          </GreenButton>
          <Button
            variant="text"
            onClick={handleClose}
            fullWidth
            style={{ marginTop: "10px" }}
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

SendBillingDialog.propTypes = {
  children: PropTypes.node,
}

export default SendBillingDialog
